import { render, staticRenderFns } from "./CategoryItemPage.vue?vue&type=template&id=1162a200&"
import script from "./CategoryItemPage.vue?vue&type=script&lang=js&"
export * from "./CategoryItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports